import React, { useEffect, useState } from 'react'
import { dependencyMapService } from '../../../services/dependencyMapService'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { Autocomplete, Box, Button, IconButton, TextField, Typography } from '@mui/material'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import DeleteIcon from '@mui/icons-material/Delete'
import { toast } from 'react-toastify'
import { FIELD_TYPES } from '../../../utility/constants'

const ParentFieldSetupUI = ({ field, activityTemplateId }) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [dependencies, setDependencies] = useState([])

  useEffect(() => {
    ;(async () => {
      const allFields = (
        await fieldTemplateService.getAllFieldsInActivity(user, activityTemplateId)
      ).data

      const allDep = await dependencyMapService.getFieldTemplateDep(user, activityTemplateId)
      const depForCurrentField = allDep?.data
        ?.filter((it) => it.child_field_template_id == field.id)
        .map((it) => allFields?.find((dep) => dep.id == it.parent_field_template_id))
        .filter((field) => field != null)
        .map((field, index) => {
          return {
            tempId: `${field?.id}-${index}-${Date.now()}`,
            value: field?.id,
            field: field,
            label: field?.field_template_name,
          }
        })
      setDependencies(depForCurrentField || [])
      setFields(
        allFields.filter(
          (it) =>
            (it.data_structure == FIELD_TYPES.LIST ||
              it.data_structure == FIELD_TYPES.LIST_MULTI) &&
            it.id != field.id
        )
      )
    })()
  }, [])

  const addRow = () => {
    setDependencies([
      ...dependencies,
      {
        tempId: `new-${Date.now()}-${Math.random()}`,
        value: null,
        field: null,
        label: 'Select Field',
      },
    ])
  }

  const saveChanges = async () => {
    try {
      const deps = dependencies.map((it) => {
        return { parent_field_template_id: it.value, child_field_template_id: field.id }
      })
      await dependencyMapService.addFieldTemplateDep(user, field.id, deps)
      toast.success('Parent child relationship updated!')
    } catch (error) {
      toast.error(error.message)
    }
  }

  const onDelete = (id) => {
    setDependencies(dependencies?.filter((it) => it.tempId != id))
  }
  return (
    <Box>
      <Typography variant="p">Select Parent Fields</Typography>
      <br />
      {dependencies
        .filter((field) => field != null)
        .map((field) => {
          const options = fields.map((it) => ({
            tempId: field?.tempId,
            value: it.id,
            field: it,
            label: it.field_template_name,
          }))
          const selectedOption = field.value 
            ? options.find((opt) => opt.value == field.value) || null
            : null
          
          return (
            <div
              key={field?.tempId}
              style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}
            >
              <Autocomplete
                value={selectedOption}
                id="autocomplete-field"
                options={options}
                getOptionLabel={(option) => option.label || ''}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params} label="Source Field" />}
                onChange={(e, v) => {
                  const updatedDependency = v ? {
                    ...field,
                    value: v.value,
                    field: v.field,
                    label: v.label,
                  } : {
                    ...field,
                    value: null,
                    field: null,
                    label: 'Select Field',
                  }
                  setDependencies(dependencies.map((it) => (it.tempId == field?.tempId ? updatedDependency : it)))
                }}
                size="small"
              />
              <IconButton onClick={() => onDelete(field.tempId)}>
                <DeleteIcon size="small" />
              </IconButton>
            </div>
          )
        })}
      <div
        style={{
          display: 'flex',
          columnGap: 16,
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 16,
        }}
      >
        <Button variant="contained" onClick={addRow}>
          Add
        </Button>
        <Button color="primary" variant="contained" onClick={saveChanges}>
          Save Changes
        </Button>
      </div>
    </Box>
  )
}

export default ParentFieldSetupUI
